import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order-return",
  "use": "icon-order-return-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-order-return\"><defs><style type=\"text/css\"></style></defs><path d=\"M984.1664 326.2464v-2.4576a27.8528 27.8528 0 0 0-0.8192-3.8912v-1.3312L908.3904 98.7136A70.144 70.144 0 0 0 841.9328 51.2H182.0672a70.144 70.144 0 0 0-66.4576 47.616L40.96 318.5664v1.3312a27.8528 27.8528 0 0 0-0.8192 3.8912v621.056A28.0576 28.0576 0 0 0 67.6864 972.8h888.6272a28.0576 28.0576 0 0 0 28.0576-28.0576V327.68s-0.1024-1.024-0.2048-1.4336zM168.7552 116.6336a14.0288 14.0288 0 0 1 13.312-9.5232h659.8656a14.0288 14.0288 0 0 1 13.312 9.5232l61.952 182.784H106.8032z m759.5008 800.1536H95.744v-561.152h832.512z\" fill=\"\" p-id=\"7596\" /><path d=\"M399.36 756.5312A28.0576 28.0576 0 1 0 438.8864 716.8l-52.5312-52.5312h317.44a28.0576 28.0576 0 1 0 0-56.1152H389.12l52.5312-52.6336a28.0576 28.0576 0 0 0-39.6288-39.6288l-102.4 102.4a28.0576 28.0576 0 0 0 0 39.6288z\" fill=\"\" p-id=\"7597\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order-return.svg
// module id = vigK
// module chunks = 26